import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import './recaptcha.js';
import './flex.js';
import './styles.js';
import './oauth.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
class NimbusCreateAccountForm extends PolymerElement {
  static get template() {
    return html`
    <style include="nimbus-flex"></style>
    <style include="nimbus-styles">
      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Italic.eot');
        src: url('fonts/NotoSans-Italic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Italic.woff') format('woff'),
          url('fonts/NotoSans-Italic.ttf') format('truetype');
        font-weight: normal;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-Bold.eot');
        src: url('fonts/NotoSans-Bold.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-Bold.woff') format('woff'),
          url('fonts/NotoSans-Bold.ttf') format('truetype');
        font-weight: bold;
        font-style: normal;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans-BoldItalic.eot');
        src: url('fonts/NotoSans-BoldItalic.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans-BoldItalic.woff') format('woff'),
          url('fonts/NotoSans-BoldItalic.ttf') format('truetype');
        font-weight: bold;
        font-style: italic;
      }

      @font-face {
        font-family: 'Noto Sans';
        src: url('fonts/NotoSans.eot');
        src: url('fonts/NotoSans.eot?#iefix') format('embedded-opentype'),
          url('fonts/NotoSans.woff') format('woff'),
          url('fonts/NotoSans.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
      .ndsgn-checkbox {
        padding:8px 0;
        font-size:0;
        text-align: left;
      }
      .ndsgn-checkbox-content {
        position:relative;
        padding:0 0 0 24px;
        min-height:16px;
        cursor:pointer;
        display:inline-block;
      }
      .ndsgn-checkbox-container {
        position:absolute;
        left:0;
        top:0;
        width:16px;
        height:16px;
        box-sizing:border-box;
        border:1px solid #cfd1d3;
        background:#fff;
      }
      .ndsgn-checkbox-container input {
        display:block;
        width:100%;
        height:100%;
        opacity:0;
        visibility:hidden;
      }
      .ndsgn-checkbox-container input + .ndsgn-checkbox-container-state {
        left:50%;
        top:50%;
        position:absolute;
        width:16px;
        height:16px;
        background: url(images/checkbox.svg) no-repeat 0px 0px;
        opacity: 0;
        visibility: hidden;

        transform:translate(-50%, -50%);
        -webkit-transform:translate(-50%, -50%);

        transition:all 0.1s ease-out;
        -webkit-transition:all 0.1s ease-out;
      }
      .ndsgn-checkbox-container input:checked + .ndsgn-checkbox-container-state {
        opacity: 1;
        visibility: visible;
      }
      .ndsgn-checkbox-label {
        font-size:12px;
      }
      .ndsgn-auth-form-top-icon-img {
        display:block;
        background:url(images/nimbus-note.svg) no-repeat center;
        width:100%;
        height:60px;
      }

      :host(.nns-theme-night) .ndsgn-auth-form-top-icon-img {
        background: url(images/nimbus-note-dark.svg) no-repeat center;
      }
    </style>

    <iron-ajax id="create_account_ajax" url="{{authUrl}}/api/create-account" method="POST" handle-as="json" on-response="handleResponse" on-error="handleError" content-type="application/json">
    </iron-ajax>
      <div class="ndsgn-auth-form-top" flex="none">
        <div class="ndsgn-auth-form-top-icon">
          <i class="ndsgn-auth-form-top-icon-img"></i>
        </div>
        <template is="dom-if" if="{{formError}}">
          <div class="ndsgn-auth-form-top-text" flex="none">[[formError]]</div>
        </template>
      </div>

      <div class="ndsgn-auth-form-main-fields" flex="none">
        <div class="ndsgn-input" class\$="[[emailClass]]">
          <input autocapitalize="none" autocorrect="off" id="email" type="text" placeholder="Email" required="" on-keypress="keypress">
          <template is="dom-if" if="{{emailError}}">
            <div class="ndsgn-input-error-text">[[emailError]]</div>
          </template>
        </div>

        <div class="ndsgn-input" class\$="[[passwordClass]]">
          <input autocapitalize="none" autocorrect="off" id="password" type="password" placeholder="Password" required="" on-keypress="keypress">
          <template is="dom-if" if="{{passwordError}}">
            <div class="ndsgn-input-error-text">[[passwordError]]</div>
          </template>
        </div>

        <div class="ndsgn-input" class\$="[[passwordRepeatClass]]">
          <input autocapitalize="none" autocorrect="off" id="password_repeat" type="password" placeholder="Repeat password" required="" on-keypress="keypress">
          <template is="dom-if" if="{{passwordRepeatError}}">
            <div class="ndsgn-input-error-text">[[passwordRepeatError]]</div>
          </template>
        </div>

        <div class="ndsgn-checkbox" flex="none">
          <label class="ndsgn-checkbox-content">
            <div class="ndsgn-checkbox-container">
              <input type="checkbox" name="" value="">
              <span class="ndsgn-checkbox-container-state"></span>
            </div>
            <div class="ndsgn-checkbox-label">Subscribe to product updates</div>
          </label>
        </div>

        <invisible-recaptcha id="recaptcha" shadow-dom="true" recaptcha-key="6LdVYSQUAAAAAHFdGp-e_GTXTSSt8EdbLhFE67om" hide-badge="true"></invisible-recaptcha>

        <div class="ndsgn-auth-form-submit">
          <button class="ndsgn-button ndsgn-button-full-width" type="submit" on-click="sendCreateAccount">
            <span class="ndsgn-button-layout" flex="" layout="row" layout-align="center center">
              Sign up
            </span>
          </button>
        </div>

      </div>

      <div class="ndsgn-auth-form-notes-text" flex="none">
        By clicking "Sign up", you agree to our<br>
        <a href="https://nimbusweb.me/terms-and-conditions.php " title="Terms and Conditions">Terms and Conditions</a>
      </div>
`;
  }

  static get is() { return "nimbus-create-account-form"; }
  static get properties() {
    return {
      'authUrl': String,
      'formError': String,
      'emailError': String,
      'emailClass': String,
      'passwordClass': String,
      'passwordError': String,
      'passwordRepeatClass': String,
      'passwordRepeatError': String
    }
  }

  constructor() {
    super()
    this.verificationFinished = this.sendData.bind(this)
  }

  connectedCallback() {
    this.shadowRoot.addEventListener("verification-finished", this.verificationFinished)
  }

  disconnectedCallback() {
    this.shadowRoot.removeEventListener("verification-finished", this.verificationFinished)
  }

  handleResponse() {
    let response = this.$.create_account_ajax.lastResponse;
    if (!response || response.error) {
      switch (response.error) {
        case 'PASSWORD_TOO_SHORT':
          this.set('passwordError', 'Password min length is 8');
          this.set('passwordClass', 'ndsgn-input ndsgn-input-invalid');
          break;
        case 'TOO_MANY_REQUESTS':
          this.set('formError', 'Please wait 30 minutes before create new account');
          break;
        case 'USER_ALREADY_EXIST':
          this.set('emailError', 'User already exist. Please sign in instead');
          this.set('emailClass', 'ndsgn-input ndsgn-input-invalid');
          break;
        case 'WRONG_EMAIL':
          this.set('emailError', 'E-mail is incorrect');
          this.set('emailClass', 'ndsgn-input ndsgn-input-invalid');
          break;
        case 'WRONG_REQUEST':
          this.set('formError', 'Something wrong');
          break;
      }
    } else {
      const event = new CustomEvent('create-account', {bubbles: true, composed: true});
      this.dispatchEvent(event);
    }
  }

  handleError() {

  }

  ready() {
    super.ready();
    this.clearErrors();
    this.$.recaptcha.render();
  }

  keypress(e) {
    var key = e.which || e.keyCode;
    if (key === 13) {
      this.sendCreateAccount();
    }
  }

  clearErrors() {
    this.set('emailError', '');
    this.set('emailClass', 'ndsgn-input');
    this.set('passwordError', '');
    this.set('passwordClass', 'ndsgn-input');
    this.set('passwordRepeatError', '');
    this.set('passwordRepeatClass', 'ndsgn-input');
    this.set('formError', '');
  }

  sendCreateAccount() {
    this.clearErrors();
    const email = this.$.email.value;
    const password = this.$.password.value;
    let passwordRepeat = this.$.password_repeat.value;
    this.$.password.value = "";
    this.$.password_repeat.value = "";
    let isError = false;
    if (!email) {
      this.set('emailError', "Field can't be empty!");
      this.set('emailClass', 'ndsgn-input ndsgn-input-invalid');
      isError = true;
    }
    if (!password) {
      this.set('passwordError', "Field can't be empty!");
      this.set('passwordClass', 'ndsgn-input ndsgn-input-invalid');
      isError = true;
    }
    if (passwordRepeat != password) {
      this.set('passwordRepeatError', "Passwords don't match!");
      this.set('passwordRepeatClass', 'ndsgn-input ndsgn-input-invalid');
      isError = true;
    }
    if (isError) {
      return;
    }
    this.email = email;
    this.password = password;

    this.$.recaptcha.verify();
  }
  sendData() {
    this.$.create_account_ajax.body = {
      email: this.email,
      password: this.password
    }

    this.$.create_account_ajax.generateRequest();
  }
}
customElements.define(NimbusCreateAccountForm.is, NimbusCreateAccountForm);
